import { Navigate, Route, Routes } from 'react-router-dom';

import { Login } from 'src/features/auth/routes/Login';

const AuthRoutes = () => {
    return (
        <Routes>
            <Route path="login" element={<Login />} />
            <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
    );
};

export { AuthRoutes };
